export default __webpack_public_path__ + "static/checknlearn-promo-small@3x-3507879ff31e67a4a6a715b6cb32f7ad.webp";